import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core'
import { RouterLink } from '@angular/router'
import { IContact } from 'src/app/schemas'
import { ApiService } from 'src/app/services'

@Component({
  selector: 'app-contacts',
  imports: [RouterLink],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss',
})
export class ContactsComponent implements OnInit {
  private apiService = inject(ApiService)
  private destroyRef = inject(DestroyRef)

  contacts = signal<IContact[]>([])
  nextUrl = signal('')
  prevUrl = signal('')
  totalCount = signal(0)
  offset = signal(0)

  private fetchContacts(url?: string) {
    const sub = this.apiService.listContacts(url).subscribe({
      next: (res) => {
        console.log('contacts:', res)
        this.contacts.set(res.results)
        this.nextUrl.set(res.next ?? '')
        this.prevUrl.set(res.previous ?? '')
        this.offset.set(res.offset)
        this.totalCount.set(res.count)
      },
    })

    this.destroyRef.onDestroy(() => sub.unsubscribe())
  }

  ngOnInit(): void {
    this.fetchContacts()
  }

  handleNext() {
    this.fetchContacts(this.nextUrl())
  }
  handlePrev() {
    this.fetchContacts(this.prevUrl())
  }
}
